import { createContext, type ReactNode, useContext } from "react";

type NavigateFn = (path: string) => void;

const ShowcaseNavigateContext = createContext<NavigateFn | null>(null);

export function ShowcaseNavigateProvider({
  navigate,
  children,
}: {
  navigate: NavigateFn;
  children: ReactNode;
}) {
  return (
    <ShowcaseNavigateContext.Provider value={navigate}>{children}</ShowcaseNavigateContext.Provider>
  );
}

export function useShowcaseNavigate(): NavigateFn {
  const navigate = useContext(ShowcaseNavigateContext);
  if (!navigate) {
    throw new Error("useShowcaseNavigate must be used within ShowcaseNavigateProvider");
  }
  return navigate;
}
